import classNames from 'classnames';
import { BookingStatusBadge } from '../../atoms';
import styles from './booking-list-item.module.scss';
import { readablePrice } from '../../helper';
import { FC } from 'react';

export type BookingListItemInfoProps = BookingStatusBadge & {
  price: {
    total: number;
  };
  renterName: string;
  project?: {
    externalProjectId: string;
    name: string;
  };
  translations: {
    totalPriceLabel: string;
    renterLabel: string;
    projectLabel: string;
  };
}

export const BookingListItemInfo: FC<BookingListItemInfoProps> = ({
  price, renterName, project, status, translations,
}) => {
  return (
    <div className={classNames(styles.orderItemInfo, styles.orderItem)}>
      <div className={styles.orderItemInfoFactsLeft}>
        <div>
          <label className={styles.label}>{translations.totalPriceLabel}:</label>
          <p className={styles.value}>
            <strong>{readablePrice(price.total)}</strong>
          </p>
        </div>

        <div>
          <label className={styles.label}>{translations.renterLabel}:</label>
          <p className={styles.value}>{renterName}</p>
        </div>
      </div>

      <div className={styles.orderItemInfoFactsRight}>
        {project && (
          <div>
            <label className={styles.label}>{translations.projectLabel}:</label>
            <p className={styles.value}>
              <strong>{project.externalProjectId}</strong><br />
              {project.name}
            </p>
          </div>
        )}

        <BookingStatusBadge status={status} translations={translations} />
      </div>
    </div>
  );
};
